import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Shell } from "@/components/Shell";
import { Empty, Loader } from "@/components/Bits";
import { PracticePanel } from "@/components/PracticePanel";

export default function Practice() {
  const [params] = useSearchParams();
  const [topics, setTopics] = useState(null);
  const [topicId, setTopicId] = useState(params.get("topic") || "");

  useEffect(() => {
    api
      .get("/library")
      .then(({ data }) => {
        if (!data.has_curriculum) return setTopics([]);
        const list = (data.tree || []).flatMap((s) =>
          s.chapters.flatMap((c) => c.topics.map((t) => ({ ...t, subject: s.name, chapter: c.name }))),
        );
        setTopics(list);
        setTopicId((prev) => prev || list[0]?.topic_id || "");
      })
      .catch(() => setTopics([]));
  }, []);

  if (!topics) return <Shell><Loader label="Loading topics…" /></Shell>;
  if (!topics.length)
    return (
      <Shell>
        <Empty title="Practice unlocks with an approved curriculum" note="Once a curriculum is live, every topic and chapter becomes an endless practice source across four tiers." />
      </Shell>
    );

  return (
    <Shell>
      <div className="reveal" data-testid="practice-root">
        <p className="rule-label">Practice Agent · unlimited generation</p>
        <h1 className="mt-3 text-3xl sm:text-4xl font-extrabold">Practice problems</h1>
        <p className="mt-2 text-sm text-slate-500">Chapter-wide practice lives inside each chapter — this is the quick single-topic drill.</p>

        <div className="mt-8 card-flat p-6">
          <label className="rule-label">Topic</label>
          <select
            data-testid="practice-topic"
            value={topicId}
            onChange={(e) => setTopicId(e.target.value)}
            className="mt-2 w-full px-4 py-2.5 rounded-xl border border-slate-300 bg-white text-sm focus:outline-none focus:border-blue-500"
          >
            {topics.map((t) => (
              <option key={t.topic_id} value={t.topic_id}>
                {`${t.subject} › ${t.chapter} › ${t.title}`}
              </option>
            ))}
          </select>
        </div>

        <div className="mt-6">{topicId && <PracticePanel key={topicId} scope="topic" id={topicId} />}</div>
      </div>
    </Shell>
  );
}
